import './background.scss';

import * as React from 'react';

export interface BackgroundProps {
    children?: React.ReactNode,
    className?: string,
}

/**
 * Background for making the back of screens look nicer.
 * @param props
 */
export const Background = (props: BackgroundProps) => {
    const { children, className } = props;

    return (
        <div className={`background ${className ?? ''}`}>
            {children}
        </div>
        );
};